export default "__VITE_ASSET__d2da8e85__"